import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function pubTravel(params = { province: province, city: city, travelTitle: travelTitle, travelTime: travelTime, travelImg: travelImg, travelDesc: travelDesc }) {
    return post(config.BASE_URL, config.pubTravelUrl, params)
}

// export function delLife(params = { id: id }) {
//     return post(config.BASE_URL, config.delLifeUrl, params)
// }

export function getTravelList(params = {}) {
    return get(config.BASE_URL, config.getTravelList, params)
}

export function getTravelDetail(params = {id: id}) {
    return get(config.BASE_URL, config.getTravelDetailUrl, params)
}

// export function getArchivesList(params = {}) {
//     return get(config.BASE_URL, config.getArchives, params)
// }

// export function getLifeListByMonthInfo(params = { date: date }) {
//     return get(config.BASE_URL, config.getLifeListByMonth, params)
// }

// export function getLifeTypeListByCount(params = {}) {
//     return get(config.BASE_URL, config.getLifeTypeListByCountUrl, params)
// }

// export function getLifeTypeList(params = {}) {
//     return get(config.BASE_URL, config.getLifeTypeListUrl, params)
// }

// export function saveLifeType(params = {}) {
//     return post(config.BASE_URL, config.saveLifeTypeUrl, params)
// }

// export function getLifeTypeAdminList(params = {}) {
//     return post(config.BASE_URL, config.getLifeTypeListAdminUrl, params)
// }

// export function delLifeType(params = { id: id }) {
//     return post(config.BASE_URL, config.delLifeTypeUrl, params)
// }